﻿/****************************************
	Polyfills
*****************************************/
(function (Element) {
	// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
	if (!Element.prototype.closest) {
		Element.prototype.closest = function closest(selector) {
			var selectorMatches = (this.document || this.ownerDocument).querySelectorAll(selector);
			var i = void 0;
			var el = this;
			do {
				// eslint-disable-line
				i = selectorMatches.length;
				while (i >= 0 && selectorMatches.item(i) !== el) {
					i -= 1;
				}
			} while (i < 0 && (el = el.parentElement)); // eslint-disable-line
			return el;
		};
	}
	// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function matches(s) {
			var matchedElements = (this.document || this.ownerDocument).querySelectorAll(s);
			var i = matchedElements.length;
			while (i >= 0 && matchedElements.item(i) !== this) {
				i -= 1;
			}
			return i > -1;
		};
	}
	// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
	if (window.NodeList && !window.NodeList.prototype.forEach) {
		window.NodeList.prototype.forEach = function loop(callback, thisArg) {
			var context = thisArg || window;
			for (var i = 0; i < this.length; i++) {
				callback.call(context, this[i], i, this);
			}
		};
	}
	// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove
	[window.Element.prototype, window.CharacterData.prototype, window.DocumentType.prototype].forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
				if (this.parentNode !== null) {
					this.parentNode.removeChild(this);
				}
			}
		});
	});
})(window.Element);
/****************************************
	Header
*****************************************/
var header = (function ($) {
	"use strict";
	/****************************************
		Transitional UI
	*****************************************/
	function warn(msg) {
		if (location.host.indexOf('.ancestry.') === -1) {
			console.warn(msg);
		}
	}
	function initUI() {
		ui = window.ui || (function () {
			warn('Using fallback window.ui methods and polyfills. Update to ancestry-ui@1.0.0 or greater.');
			/* Helper Methods */
			return {
				deleteCookie: function deleteCookie(cookieName) {
					document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
				},
				getCookie: function getCookie(name) {
					var cookieName = name + '=';
					var cookies = document.cookie.split(';');
					var len = cookies.length;
					var cookie;
					var i;
					for (i = 0; i < len; i += 1) {
						cookie = cookies[i].trim();
						if (cookie.indexOf(cookieName) === 0) {
							return cookie.substring(cookieName.length, cookie.length);
						}
					}
					return '';
				},
				getRandomNumber: function getRandomNumber(min, max) {
					if (!Number.isNaN(min) && !Number.isNaN(max)) {
						return Math.floor(Math.random() * (1 + max - min) + min);
					}
					return Date.now().toString() + Math.floor(Math.random() * 1000 + 1);
				},
				setCookie: function setCookie(cookieName, value, daysUntilExpiration, domain, path) {
					var expires;
					var d = new Date();
					var secondsInDay = 24 * 60 * 60 * 1000;
					daysUntilExpiration = daysUntilExpiration || 90;
					d.setTime(d.getTime() + daysUntilExpiration * secondsInDay);
					expires = 'expires=' + d.toUTCString();
					domain = domain || window.location.hostname.replace(/.+?\./, '.');
					path = path || '/';
					document.cookie = cookieName + '=' + value + '; ' + expires + '; ' + (domain ? 'domain=' + domain + '; ' : '') + (path ? 'path=' + path + '; ' : '');
				},
				setDictionaryCookie: function setDictionaryCookie(cookieName, keyName, value, daysUntilExpiration, domain, path) {
					var name = cookieName.toUpperCase();
					var key = keyName.toUpperCase();
					var dictionary = this.getCookie(name);
					if (dictionary === null || dictionary === undefined) {
						dictionary = key + '=' + value;
					} else {
						var dictSrc = dictionary.toLowerCase();
						var startKey = dictSrc.indexOf(key.toLowerCase() + '=');
						if (startKey === -1) {
							/* key was not there */
							if (dictionary.length > 0) {
								dictionary = dictionary + '&';
							}
							dictionary = '' + dictionary + key + '=' + value;
						} else {
							var endKey = dictSrc.indexOf('&', startKey);
							if (endKey === -1) {
								/* no keys after */
								if (startKey === 0) {
									/* no keys before and no keys after */
									dictionary = key + '=' + value;
								} else {
									/* keys before not after */
									dictionary = '' + dictionary.substring(0, startKey) + key + '=' + value;
								}
							} else {
								/* key is somewhere in middle */
								dictSrc = dictionary;
								dictionary = '';
								if (startKey > 0) {
									/* keys before */
									dictionary = dictSrc.substring(0, startKey);
								}
								dictionary = '' + dictionary + key + '=' + value + dictSrc.substring(endKey);
							}
						}
					}
					this.setCookie(name, dictionary, daysUntilExpiration, domain, path);
				},
				visible: function visible(element) {
					var cond1 = !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
					function getAllParentNodes(elm) {
						var currNode = elm;
						var parentsList = [];
						while (currNode && currNode.parentNode && currNode !== currNode.parentNode) {
							parentsList.push(currNode.parentNode);
							currNode = currNode.parentNode;
						}
						return parentsList;
					}
					var cond2 = !Array.prototype.filter.call(getAllParentNodes(element).push(element), function (i, ele) {
						return window.getComputedStyle(ele).visibility === 'hidden';
					}).length;
					return cond1 && cond2;
				}
			};
		})();
	}
	var ui,
		user,
		expertLink,
		expertModal,
		navSecondaryMenu,
		navMobileMenu,
		obj = {},
		instance,
		callouts = {},
		badgeCookieName = 'navbadges',
		phxCartCookieName = 'shopping-cart-cell',
		phxCartCookieCountName = 'PhxCartCheckout',
		phxCartRequested = false,
		tempPhxCartObj,
		inCartTest = false,
		lastRequestedTime = {},
		resizeBound = false,
		templates = null,
		settings = {
			'isLoggedIn': false,
			'dnaUrl': 'https://www.ancestry.com/dna',
			'ajaxUrl': 'https://www.ancestry.com/navigation/ajax/userdata/2.1',
			'hintsAjaxUrl': 'https://www.ancestry.com/navigation/ajax/Hints',
			'messagesAjaxUrl': 'https://www.ancestry.com/navigation/ajax/Messages',
			'treesAjaxUrl': 'https://www.ancestry.com/navigation/ajax/Trees',
			'dnaNotificationsAjaxUrl': 'https://www.ancestry.com/navigation/ajax/DnaHints',
			'userAjaxUrl': 'https://www.ancestry.com/navigation/ajax/UserInfo',
			'clearUserDataUrl': 'https://www.ancestry.com/navigation/ajax/Clear',
			'clearCartUrl': 'https://www.ancestry.com/navigation/ajax/ClearCart',
			'selectedTabName': false,
			'jQueryTimeout': 10000,
			'cookieDomain': 'ancestry.com'
		};
	/****************************************
		Utility Methods
	*****************************************/
	function ajax(options) {
		if (options.testResponse) {
			setTimeout(function () {
				options.success(options.testResponse);
			}, instance.testing.ajaxDelay || 500);
			return;
		}
		var combiner = options.url.indexOf('?') > -1 ? '&' : '?',
			callbackName = 'headerCallback' + ui.getRandomNumber(),
			script = document.createElement('script');
		script.src = options.url + combiner + 'callback=' + callbackName;
		script.id = 'headerApiScript';
		script.async = true;
		window[callbackName] = function ajaxSuccess(data) {
			document.getElementById('headerApiScript').remove();
			var results = typeof data === 'string' ? JSON.parse(data) : data; // IE 11 fix
			if (options.success) {
				options.success(results);
			}
		};
		document.head.appendChild(script);
	}
	function getDateHtml(birth, death) {
		if (birth && death) {
			return '<em>' + birth + ' - ' + death + '</em>';
		}
		if (birth) {
			return '<em>' + birth + '</em>';
		}
		if (death) {
			return '<em>' + death + '</em>';
		}
		return '';
	}
	function objectsAreIdentical(obj1, obj2) {
		return JSON.stringify(obj1) === JSON.stringify(obj2);
	}
	function updateQueryStringParameter(uri, key, value) {
		var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i'),
			separator = uri.indexOf('?') !== -1 ? '&' : '?';
		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		return uri + separator + key + '=' + value;
	}
	/****************************************
		Event Handling
	*****************************************/
	function bindBusEvents() {
		if (window.acom && window.acom.bus) {
			window.acom.bus.on('PersonHintTab::hintcount_change::pending', function () {
				header.updateUserData('hints');
			});
		} else {
			setTimeout(function () {
				if (window.acom && window.acom.bus) {
					window.acom.bus.on('PersonHintTab::hintcount_change::pending', function () {
						header.updateUserData('hints');
					});
				}
			}, 500);
		}
	}
	function bindDnaLoad() {
		/* This method exists to mock a server-side load of the DNA menu items until a true server-side caching method is implemented. */
		var navDna = document.getElementById('navDna');
		var navDnaMenu = document.getElementById('navDnaMenu');
		if (!instance.isLoggedIn || !navDna || !navDna.hasAttribute('aria-controls')) {
			return;
		}
		navDna.addEventListener('focusin', loadDna);
		navDna.addEventListener('mouseenter', loadDna);
		navDnaMenu.addEventListener('focusin', loadDna);
		navDnaMenu.addEventListener('mouseenter', loadDna);
		navDnaMenu.addEventListener('touchstart', loadDna);
		/* focusin is for Assistive Technologies on mobile. mouseenter is for desktop screens scaled down. touchstart is for default mobile interactions. */
	}
	function bindEvents() {
		bindWindowResize();
		bindSkipLink();
		bindBusEvents();
		bindLanguageToggle();
		bindDnaLoad();
		bindTracking();
		bindSubMenus();
	}
	function bindExpertWarning() {
		var nav = document.getElementById('nav'),
			links = document.querySelectorAll('#nav a[href*="//www.progenealogists.com"]');
		nav.removeEventListener('click', expertWarning);
		nav.addEventListener('click', expertWarning);
		links.forEach(function (el) {
			el.removeEventListener('click', expertWarning);
			el.addEventListener('click', expertWarning);
		});
	}
	function bindLanguageToggle() {
		var navLanguageToggle = document.querySelector('.navLanguageToggle');
		if (!navLanguageToggle) {
			return;
		}
		navLanguageToggle.removeEventListener('click', handleLanguageToggle);
		navLanguageToggle.addEventListener('click', handleLanguageToggle);
	}
	function bindSeeMoreDnaButton() {
		var seeMore = document.getElementById('navSeeMoreDnaNotifications');
		seeMore.removeEventListener('click', seeMoreDna);
		seeMore.addEventListener('click', seeMoreDna);
	}
	function bindSkipLink() {
		/* Workaround for IE 11 choking on the "Skip to navigation link". */
		var skipLink = document.getElementById('navSkip');
		if (!skipLink) {
			return;
		}
		skipLink.removeEventListener('keydown', handleSkipLink);
		skipLink.addEventListener('keydown', handleSkipLink);
	}
	function bindSubMenus() {
		var nav = document.getElementById('nav'),
			navVersion = nav.getAttribute('data-nav-version'),
			menus = nav.getElementsByClassName('navSubMenu'),
			navMobileMenu = document.querySelector('.navMobileMenu'),
			seeAll = document.getElementById('navSeeAllHintsIn'),
			i;
		for (i = menus.length - 1; i > 0; i--) {
			menus[i].classList.add(navVersion);
		}
		initCalloutSubMenus();
		nav.addEventListener('focusout', focusedOffNav);
		document.querySelectorAll('.navSubMenu').forEach(function (el) {
			el.addEventListener('keydown', navSubMenuKeyDown);
		});
		if (navMobileMenu) {
			navMobileMenu.addEventListener('keydown', handleMobileKeyDown);
			navMobileMenu.addEventListener('click', expandSubMenu);
		}
		if (instance.isLoggedIn && seeAll) {
			seeAll.addEventListener('click', handleSeeAllHintsClick);
		}
	}
	function handleClickTracking(e) {
		var target = e.target,
			link = target && target.closest('[data-tracking-name]'),
			isWithinNav = link && (link.closest('.navSubMenu, .navMobileMenu') || link.closest('.nav') || link.closest('#progenLeavingAncestryModal'));
		if (!link || !isWithinNav) {
			return;
		}
		var isCalloutTrigger = link.classList.contains('calloutTrigger'),
			isClosing = link.classList.contains('closing'),
			isCartMenu = link.id === 'navCart';
		if (!isCalloutTrigger || (isCalloutTrigger && isClosing && !isCartMenu) || (isCalloutTrigger && isCartMenu)) {
			fireTracking(link.getAttribute('data-tracking-name'));
		}
	}
	function bindTracking() {
		if (instance.addTracking) {
			document.body.addEventListener('click', handleClickTracking);
		}
	}
	function bindWindowResize() {
		var debounce;
		if (resizeBound) {
			return;
		}
		window.addEventListener('resize', function () {
			clearTimeout(debounce);
			debounce = setTimeout(function () {
				destroyHiddenSubMenus();
				initCalloutSubMenus();
			}, 1000);
		});
		resizeBound = true;
	}
	function clearCart() {
		var options = {
			'url': instance.clearCartUrl + '?customerId=' + instance.userId,
			'success': function (data) {
				if (data) {
					var cart = document.getElementById('navCart');
					if (cart) {
						cart.classList.add('noDisplay');
					}
					var button = document.querySelector('.navSecondaryMenu .navEmphasizedButton, .navSecondaryMenu .navEmphasizedExpertButton');
					if (button) {
						button.classList.remove('noDisplay');
					}
				}
			}
		};
		ajax(options);
	}
	function clearHints() {
		var options = {
			'url': instance.hintsClearAllUrl + '?customerId=' + instance.userId,
			'success': function (data) {
				if (data) {
					document.querySelectorAll('#navHints .badge').forEach(function (el) {
						el.classList.add('noDisplay'); // TODO: Fade out
					});
				}
			}
		};
		ajax(options);
	}
	function clickedBadge(e) {
		var badge = e.target.querySelector('.badge[data-badge-viewed]');
		if (!e.target.closest('a') || !badge) {
			return;
		}
		badge.setAttribute('data-badge-clicked', 'true');
		setBadgeCookie();
	}
	function doCalloutThing(el, method) {
		if (ui.callout && el.id && callouts[el.id]) {
			callouts[el.id][method]();
			if (method === 'destroy') {
				callouts[el.id] = null;
			}
		} else if (window.$ && window.$.callout) {
			$(el).callout(method);
		}
	}
	function clearDnaNotifications() {
		var badge = document.querySelector('#navDnaNotifications .badge');
		if (badge) {
			badge.classList.add('noDisplay'); // TODO: Fade out
		}
	}
	function destroyHiddenSubMenus() {
		document.querySelectorAll('#nav .initialized[aria-controls]').forEach(function (el) {
			if (ui.visible(el)) {
				return; // Only init visible callouts
			}
			el.classList.remove('initialized');
			el.removeEventListener('keyup', handleKeyUp);
			el.removeEventListener('keydown', handleKeyDown);
			if (callouts[el.id] && callouts[el.id].contentElement) {
				var id = el.id === 'navMobile' ? 'nav' : 'navMobileMenu';
				document.getElementById(id).appendChild(callouts[el.id].contentElement.firstChild); // put contents back into DOM for 2.0 compatibility
			}
			doCalloutThing(el, 'destroy');
		});
	}
	function expandSubMenu(e) {
		var target = e.target;
		var currentSubMenu = target.closest('.navSubMenu');
		if (!target.closest('.calloutMenuTitle') || !currentSubMenu) {
			return;
		}
		currentSubMenu.parentNode.querySelectorAll('.navSubMenu').forEach(function (el) {
			if (el === currentSubMenu) {
				el.classList.toggle('navSubMenuExpanded');
			} else {
				el.classList.remove('navSubMenuExpanded');
			}
		});
	}
	function expertWarning(e) {
		if (!e.target.matches('a[href*="//www.progenealogists.com"]')) {
			return;
		}
		var progenLogo = document.getElementById('navProgenLogo');
		if (progenLogo) {
			progenLogo.innerHTML = '<img class="navProgenLogo" alt="' + progenLogo.getAttribute('data-alt') + '" src="' + progenLogo.getAttribute('data-src') + '" />';
		}
		if ($ && $.modal) {
			$('#progenLeavingAncestryModal').css('display', '').modal({ 'width': 500 });
			e.preventDefault();
		} else if (ui && ui.modal) {
			if (expertModal) {
				expertModal.open();
			} else {
				var progenModal = document.getElementById('progenLeavingAncestryModal');
				progenModal.style.display = '';
				expertModal = ui.modal(progenModal, { 'width': 500, 'open': true });
			}
			e.preventDefault();
		} else {
			var text = document.getElementById('progenMessage').innerText;
			if (!window.confirm(text)) {
				e.preventDefault();
			}
			warn('Header Error: Missing core.js dependency. DO NOT IGNORE. This is an issue with your page.');
		}
	}
	function fireTracking(trackingName) {
		if (!window.utag) {
			warn('Omniture Unavailable : ' + trackingName);
		} else {
			window.utag.link({
				"link_name" : trackingName,
				"action": "ancestry : navigation : " + trackingName
			});
		}
	}
	function focusedOffNav() {
		var activeCalloutTrigger = document.querySelector('.calloutTrigger.active');
		if (!activeCalloutTrigger) {
			return;
		}
		setTimeout(function () {
			var active = document.activeElement;
			var focusedInCallout = active.closest('.calloutContent');
			var previousCalloutIsStillOpen = activeCalloutTrigger.classList.contains('active');
			if (active && previousCalloutIsStillOpen && !focusedInCallout) {
				doCalloutThing(activeCalloutTrigger, 'close');
			}
		}, 200);
	}
	function handleBadges() {
		var now = Date.now(),
			badges = retrieveUserBadgesFromCookie();
		document.querySelectorAll('#navMobileMenu .navSubMenu').forEach(function (el) {
			var count = 0;
			el.querySelectorAll('.badge').forEach(function (badge) {
				// If badge not present in cookie and expiration is after now, show badge and increase count
				var id = badge.id,
					expiration = Date.parse(badge.getAttribute('data-badge-expiration')),
					countBadge = true;
				if ((badges && badges.viewed && badges.viewed.indexOf(id) !== -1) || expiration <= now) {
					countBadge = false;
					badge.setAttribute('data-badge-viewed', 'true');
				}
				if (!badges || (badges && !badges.clicked) || (badges && badges.clicked && badges.clicked.indexOf(id) === -1)) {
					if (expiration > now) {
						badge.classList.remove('noDisplay');
					}
				} else {
					badge.setAttribute('data-badge-clicked', 'true');
				}
				if (countBadge) {
					count++;
				}
			});
			if (count > 0) {
				var node = document.getElementById(el.getAttribute('aria-labelledby'));
				node.querySelectorAll('.badge').forEach(function (badge) {
					badge.remove();
				});
				node.insertAdjacentHTML('beforeend', ' ' + templates.templateBadge.replace('{text}', count));
			}
		});
	}
	function handleFailedMenu(id) {
		doCalloutThing(document.getElementById(id), 'destroy');
	}
	function handleKeyDown(e) {
		var target = e.currentTarget,
			targetMenu = document.querySelector('.' + target.getAttribute('aria-controls')),
			subMenuItems = targetMenu ? targetMenu.querySelectorAll('a') : [],
			visibleSubMenuItems = [];
		subMenuItems.forEach(function (el) {
			if (ui.visible(el)) {
				visibleSubMenuItems.push(el);
			}
		});
		if (e.keyCode === 40 || e.keyCode === 32) {
			if (visibleSubMenuItems[0]) {
				visibleSubMenuItems[0].focus();
			}
			e.preventDefault();
			e.stopPropagation();
		} else if (e.keyCode === 38) {
			visibleSubMenuItems[visibleSubMenuItems.length - 1].focus();
			e.preventDefault();
			e.stopPropagation();
		}
	}
	function handleKeyUp(e) {
		if (e.keyCode === 32) {
			doCalloutThing(e.currentTarget, 'open');
		}
	}
	function handleKeyboardNavigation(e, link, menu) {
		var newLink,
			closestSubMenu,
			isMobileMenu = menu.classList.contains('navMobileMenu'),
			subMenuItems = [].slice.call(menu.querySelectorAll('a, button')).filter(function (el) { return ui.visible(el); }),
			currentIndex = subMenuItems.indexOf(link),
			subMenuItemsCount = subMenuItems.length,
			isUpKey = e.keyCode === 38,
			isTabbingUp = e.keyCode === 9 && e.shiftKey,
			isDownKey = e.keyCode === 40,
			isTabbingDown = e.keyCode === 9 && !e.shiftKey;
		if (isDownKey || isTabbingDown) {
			newLink = subMenuItems[currentIndex + 1 >= subMenuItemsCount ? 0 : currentIndex + 1];
			if (isMobileMenu) {
				closestSubMenu = newLink.closest('.navSubMenu');
				if (closestSubMenu && !closestSubMenu.classList.contains('navSubMenuExpanded')) {
					expandSubMenu({ target: closestSubMenu.querySelector('.calloutMenuTitle') });
				}
			}
			if (isDownKey) {
				newLink.focus();
				e.preventDefault();
				e.stopPropagation();
			}
		} else if (isUpKey || isTabbingUp) {
			var newIndex = subMenuItems.indexOf(link) - 1;
			newLink = subMenuItems[newIndex >= 0 ? newIndex : subMenuItems.length - 1];
			if (isMobileMenu) {
				closestSubMenu = newLink.closest('.navSubMenu');
				if (closestSubMenu && !closestSubMenu.classList.contains('navSubMenuExpanded')) {
					expandSubMenu({ target: closestSubMenu.querySelector('.calloutMenuTitle') });
				}
			}
			if (isUpKey) {
				newLink.focus();
				e.preventDefault();
				e.stopPropagation();
			}
		}
	}
	function handleLanguageToggle(e) {
		var languageId = e.currentTarget.getAttribute('data-language-id'),
			languageName = e.currentTarget.getAttribute('data-language-name'),
			daysToExpiration = 3560; /* 10 Years */
		ui.setDictionaryCookie('VARS', 'LCID', languageId, daysToExpiration);
		ui.setDictionaryCookie('VARS', 'LCISONAME', languageName, daysToExpiration);
		var windowLoc = '' + window.location,
			newWindowLoc = windowLoc.replace(/lcid=\d{4}/ig, 'lcid=' + languageId);
		if (windowLoc === newWindowLoc) {
			window.location.reload();
		} else {
			window.location = newWindowLoc;
		}
	}
	function handleMobileKeyDown(e) {
		var target = e.target;
		if (target.matches('a')) {
			handleKeyboardNavigation(e, target, target.closest('.navMobileMenu'));
		}
	}
	function handleDisplayOfSeeMoreDnaButton() {
		var hiddenNotifications = [].slice.call(document.querySelectorAll('#navDnaNotificationsList .navListItem:not(:visible)')).filter(function (el) { return ui.visible(el); }),
			seeMoreButton = document.getElementById('navSeeMoreDnaNotifications');
		if (hiddenNotifications) {
			seeMoreButton.classList.remove('noDisplay');
		} else {
			seeMoreButton.classList.add('noDisplay');
		}
	}
	function handleSeeAllHintsClick(e) {
		var target = e.target;
		var navSeeAllHintsMenuEl = document.getElementById('navSeeAllHintsMenu');
		if (!navSeeAllHintsMenuEl) {
			return;
		}
		if (navSeeAllHintsMenuEl.classList.contains('noDisplay')) {
			target.setAttribute('aria-expanded', 'true');
			navSeeAllHintsMenuEl.classList.remove('noDisplay');
		} else {
			target.setAttribute('aria-expanded', 'false');
			navSeeAllHintsMenuEl.classList.add('noDisplay');
		}
	}
	function handleSkipLink(e) {
		var target = document.querySelector(e.target.getAttribute('href'));
		if (e.keyCode === 13 || e.keyCode === 32) {
			if (!target.getAttribute('tabindex')) {
				var blurHandler = function () {
					target.removeAttribute('tabindex');
					target.removeEventListener('blur', blurHandler);
				};
				target.setAttribute('tabindex', '-1');
				target.addEventListener('blur', blurHandler);
			}
			target.focus();
			e.preventDefault();
			e.stopPropagation();
		}
	}
	function hideLoadingMessageOnSubmenu(submenuId) {
		var submenu = document.getElementById(submenuId + 'Loading');
		if (!submenu) {
			return;
		}
		submenu.setAttribute('aria-busy', 'false');
		submenu.classList.add('noDisplay');
	}
	function loadDna(e) {
		unbindDnaLoad();
		loadSubMenu(instance.dnaUrl + '/rest/headerinfo', renderDna, 'dna');
	}
	function loadSubMenu(url, callback, key) {
		var currentTime = Date.now(),
			timeBetweenRequests = 5000,
			options = {
				'url': url,
				'success': callback,
				'error': callback
			};
		if (instance.testing) {
			options.testResponse = instance.testing[key];
		}
		/* Debounce menus from being requested multiple times in rapid succession */
		if (currentTime > (lastRequestedTime[key] || 0) + timeBetweenRequests) {
			lastRequestedTime[key] = currentTime;
			ajax(options);
		}
	}
	function navSubMenuKeyDown(e) {
		var target = e.target;
		if (!target.matches('a, .link') || target.closest('.navMobileMenu')) {
			return;
		}
		handleKeyboardNavigation(e, target, target.closest('.navSubMenu'));
	}
	function retrieveUserBadgesFromCookie() {
		var badges = retrieveBadgesFromCookie();
		if (badges[instance.userId]) {
			badges = badges[instance.userId];
		} else {
			badges = false;
		}
		return badges;
	}
	function retrieveBadgesFromCookie() {
		var badges = ui.getCookie(badgeCookieName);
		if (badges.length) {
			badges = JSON.parse(badges);
		} else {
			badges = false;
		}
		return badges;
	}
	function requestTreesData(e) {
		if (!e.target.closest('a')) {
			return;
		}
		e.currentTarget.removeEventListener('click', requestTreesData);
		ajax({ 'url': instance.clearUserDataUrl + '?trees=true' });
	}
	function seeMoreDna() {
		var navDnaNotificationsList = document.getElementById('navDnaNotificationsList'),
			visibleItems = [].slice.call(navDnaNotificationsList.querySelectorAll('.navListItem')).forEach(function (el) {
				return ui.visible(el);
			}),
			lastVisibleItem = visibleItems.pop(),
			focusedOffDna = function (e) {
				lastVisibleItem.removeEventListener('focusout', focusedOffDna);
				e.currentTarget.classList.remove('navHideHighlight');
			};
		navDnaNotificationsList.querySelectorAll('.navListItem').forEach(function (el) {
			el.classList.add('navShowListItem');
		});
		lastVisibleItem
			.nextSibling
			.querySelectorAll('a')
			.forEach(function (link) {
				link.classList.add('navHideHighlight');
			});
		lastVisibleItem.focus();
		lastVisibleItem.addEventListener('focusout', focusedOffDna);
		handleDisplayOfSeeMoreDnaButton();
	}
	function setBadgeCookie() {
		var badges = retrieveBadgesFromCookie() || {},
			newViewedBadgeIds = [],
			newClickedBadgeIds = [];
		document.querySelectorAll('.navSubMenu').navSubMenus.forEach(function (el) {
			el.querySelectorAll('.badge[data-badge-id]').forEach(function (badge) {
				if (badge.getAttribute('data-badge-viewed')) {
					newViewedBadgeIds.push(badge.getAttribute('data-badge-id'));
				}
				if (badge.getAttribute('data-badge-clicked')) {
					newClickedBadgeIds.push(badge.getAttribute('data-badge-id'));
				}
			});
		});
		if (!newViewedBadgeIds.length && !newClickedBadgeIds.length) {
			ui.deleteCookie(badgeCookieName);
		} else {
			badges[instance.userId] = {};
			if (newViewedBadgeIds.length) {
				badges[instance.userId].viewed = newViewedBadgeIds;
			}
			if (newClickedBadgeIds.length) {
				badges[instance.userId].clicked = newClickedBadgeIds;
			}
			ui.setCookie(badgeCookieName, JSON.stringify(badges), 90);
		}
	}
	function unbindClickTracking() {
		document.body.removeEventListener('click', handleClickTracking);
	}
	function unbindDnaLoad() {
		var navDna = document.getElementById('navDna');
		var navDnaMenu = document.getElementById('navDnaMenu');
		if (!navDna) {
			return;
		}
		navDna.removeEventListener('focusin', loadDna);
		navDna.removeEventListener('mouseenter', loadDna);
		if (!navDnaMenu) {
			return;
		}
		navDnaMenu.removeEventListener('focusin', loadDna);
		navDnaMenu.removeEventListener('mouseenter', loadDna);
		navDnaMenu.removeEventListener('touchstart', loadDna);
	}
	function unbindEvents() {
		unbindDnaLoad();
		unbindFocusedOffNav();
		unbindSubMenus();
		unbindClickTracking();
	}
	function unbindFocusedOffNav() {
		document.getElementById('nav').addEventListener('focusout', focusedOffNav);
	}
	function unbindSubMenus() {
		var navMobileMenu = document.querySelector('.navMobileMenu');
		if (navMobileMenu) {
			navMobileMenu.removeEventListener('keydown', handleMobileKeyDown);
			navMobileMenu.removeEventListener('click', expandSubMenu);
		}
		var seeAll = document.getElementById('navSeeAllHintsIn');
		if (seeAll) {
			seeAll.removeEventListener('click', handleSeeAllHintsClick);
		}
		document.querySelectorAll('.navSubMenu').forEach(function (el) {
			el.removeEventListener('keydown', navSubMenuKeyDown);
		});
	}
	/****************************************
		Rendering Markup
	*****************************************/
	function renderCachedMenuOrDisplayLoadingMessage(key, menuId, renderingFunction) {
		if (instance.cachedData && instance.cachedData[key] && instance.cachedData[key].success) {
			renderingFunction(instance.cachedData[key]);
		} else {
			showLoadingMessageOnSubmenu(menuId);
		}
	}
	function renderDna(data) {
		var i,
			menuLength = 0,
			menuList = '',
			id = 'navDna',
			navDna = document.getElementById(id),
			navDnaMenu = document.querySelector('.navDnaMenu');
		if (data) {
			data = data.results;
		}
		if (!data || !data.menuitems || !navDna || !navDnaMenu) {
			return false;
		}
		menuLength = data.menuitems.length;
		for (i = 0; i < menuLength; i += 1) {
			var trackingName = data.menuitems[i].trackingName || 'DNA Menu Item';
			menuList += '<li><a data-tracking-name="' + trackingName + '" href="' + data.menuitems[i].url + '"' + (!!data.target ? ' target="' + data.target + '"' : '') + '>' + data.menuitems[i].text + '</a></li>';
		}
		navDnaMenu.querySelector('ul').innerHTML = menuList;
		if (callouts[id]) {
			doCalloutThing(navDna, 'position'); /* Reposition callout since it doesn't have a fixed width */
		}
	}
	function renderDnaNotifications(data) {
		var i,
			menuLength,
			gender,
			html = '',
			item,
			genderIcon,
			navDnaNotifications = document.getElementById('navDnaNotifications'),
			navDnaNotificationsMenu = document.getElementById('navDnaNotificationsMenu');
		// If no menu items
		if (!navDnaNotifications || !navDnaNotificationsMenu) {
			return false;
		}
		// If bad new data or new data is same as old
		if (!data || data.success !== true || objectsAreIdentical(instance.cachedData.navDnaNotificationsMenu, data)) {
			if (!instance.cachedData.navDnaNotificationsMenu) { // If bad new data and no old data, remove the callout
				handleFailedMenu('navDnaNotifications');
			}
			return false;
		}
		instance.cachedData.navDnaNotificationsMenu = data;
		menuLength = data.menuitems.length;
		if (menuLength > 0) {
			for (i = 0; i < menuLength; i += 1) {
				var menuItem = data.menuitems[i];
				item = templates.templateNotification
					.replace('{url}', menuItem.url)
					.replace('{unread}', menuItem.unread ? 'navUnread' : '')
					.replace('{tracking}', 'DNA Notification' + (menuItem.unread ? ' Unread' : ''));
				if (menuItem.img) {
					item = item.replace('{image}', templates.templateNotificationUsercardImage.replace('{imageUrl}', menuItem.img));
				} else {
					gender = (menuItem.gender || '').toLowerCase();
					if (gender === 'male') {
						genderIcon = 'Male';
					} else if (gender === 'female') {
						genderIcon = 'Female';
					} else {
						genderIcon = 'Person';
					}
					item = item.replace('{image}', templates.templateNotificationUsercardIcon.replace('{icon}', genderIcon));
				}
				item = item
					.replace('{title}', menuItem.title)
					.replace('{badge}', !menuItem.visited ? templates.templateBadge.replace('{text}', templates.templateNew) : '')
					.replace('{subtitle}', menuItem.name)
					.replace('{meta}', menuItem.date + ', ' + menuItem.test);
				html += item;
			}
			document.getElementById('navDnaNotificationsList').innerHTML = html;
			document.getElementById('navHasDnaNotifications').classList.remove('noDisplay');
			document.getElementById('navNoDnaNotifications').classList.add('noDisplay');
			bindSeeMoreDnaButton();
			handleDisplayOfSeeMoreDnaButton();
		} else {
			document.getElementById('navNoDnaNotifications').classList.remove('noDisplay');
			document.getElementById('navHasDnaNotifications').classList.add('noDisplay');
		}
		hideLoadingMessageOnSubmenu('navDnaNotificationsMenu');
	}
	function renderHints(data) {
		var i,
			meta,
			html = '',
			item = '',
			hintIcon,
			menuLength,
			treesLength,
			navHints = document.getElementById('navHints'),
			navHintsMenu = document.getElementById('navHintsMenu');
		// If no menu items
		if (!navHints || !navHintsMenu) {
			return false;
		}
		// If bad new data or new data is same as old
		if (!data || data.success !== true || objectsAreIdentical(instance.cachedData.navHintsMenu, data)) {
			if (!instance.cachedData.navHintsMenu) { // If bad new data and no old data, remove the callout
				handleFailedMenu('navHints');
			}
			return false;
		}
		instance.cachedData.navHintsMenu = data;
		menuLength = data.menuitems.length;
		treesLength = data.trees.length;
		if (menuLength > 0) {
			for (i = 0; i < menuLength; i += 1) {
				var menuItem = data.menuitems[i];
				if (menuItem.type === 'Person') {
					hintIcon = 'Person';
				} else if (menuItem.type === 'Photo') {
					hintIcon = 'Image';
				} else if (menuItem.type === 'Story') {
					hintIcon = 'Story';
				} else { // if (menuItem.type === 'Record') {
					hintIcon = 'Note';
				}
				meta = getDateHtml(menuItem.birth, menuItem.death);
				if (meta.length && treesLength > 1) {
					meta += ', ';
				}
				meta += (treesLength > 1 ? menuItem.treeName : '');
				item = templates.templateNotification
					.replace('{url}', menuItem.url)
					.replace('{unread}', menuItem.unread ? 'navUnread' : '')
					.replace('{image}', templates.templateNotificationUsercardIcon.replace('{icon}', hintIcon))
					.replace('{title}', menuItem.title)
					.replace('{badge}', menuItem.unread ? templates.templateBadge.replace('{text}', templates.templateNew) : '')
					.replace('{subtitle}', menuItem.name)
					.replace('{meta}', meta)
					.replace('{tracking}', 'Hint' + (menuItem.unread ? ' New' : ''));
				html += item;
			}
			document.getElementById('navHintsList').innerHTML = html;
			document.getElementById('navNoHints').classList.add('noDisplay');
			document.getElementById('navHasHints').classList.remove('noDisplay');
		} else {
			document.getElementById('navNoHints').classList.remove('noDisplay');
			document.getElementById('navHasHints').classList.add('noDisplay');
		}
		if (treesLength > 1) {
			html = '';
			for (i = 0; i < treesLength; i += 1) {
				html += '<li><a data-tracking-name="Hints in Specific Tree" href="' + data.trees[i].url + '">' + data.trees[i].text + '</a></li>';
			}
			document.getElementById('navSeeAllHintsMenu').innerHTML = html;
			document.getElementById('navSeeAllHints').classList.add('noDisplay');
			document.getElementById('navSeeAllHintsIn').classList.remove('noDisplay');
		} else {
			document.getElementById('navSeeAllHints').classList.remove('noDisplay');
			document.getElementById('navSeeAllHintsIn').classList.add('noDisplay');
		}
		hideLoadingMessageOnSubmenu('navHintsMenu');
	}
	function renderMessages(data) {
		var i,
			menuLength,
			html = '',
			item = '',
			navMessages = document.getElementById('navMessages'),
			navMessagesMenu = document.getElementById('navMessagesMenu');
		// If no menu items
		if (!navMessages || !navMessagesMenu) {
			return false;
		}
		// If bad new data or new data is same as old
		if (!data || data.success !== true || objectsAreIdentical(instance.cachedData.navMessagesMenu, data)) {
			if (!instance.cachedData.navMessagesMenu) { // If bad new data and no old data, remove the callout
				handleFailedMenu('navMessages');
			}
			return false;
		}
		instance.cachedData.navMessagesMenu = data;
		menuLength = data.menuitems.length;
		if (menuLength > 0) {
			for (i = 0; i < menuLength; i += 1) {
				var menuItem = data.menuitems[i];
				item = templates.templateNotification
					.replace('{url}', menuItem.url)
					.replace('{unread}', menuItem.unread ? 'navUnread' : '')
					.replace('{tracking}', 'Message' + (menuItem.unread ? ' New' : ''));
				if (menuItem.img && menuItem.img.length) {
					item = item.replace('{image}', templates.templateNotificationUsercardImage.replace('{imageUrl}', menuItem.img));
				} else {
					item = item.replace('{image}', templates.templateNotificationUsercardIcon.replace('{icon}', 'Person'));
				}
				item = item
					.replace('{title}', menuItem.username)
					.replace('{badge}', menuItem.unread ? templates.templateBadge.replace('{text}', templates.templateNew) : '')
					.replace('{subtitle}', menuItem.text)
					.replace('{meta}', menuItem.date + ', ' + menuItem.subject);
				html += item;
			}
			document.getElementById('navMessagesList').innerHTML = html;
			document.getElementById('navNoMessages').classList.add('noDisplay');
			document.getElementById('navHasMessages').classList.remove('noDisplay');
		} else {
			document.getElementById('navNoMessages').classList.remove('noDisplay');
			document.getElementById('navHasMessages').classList.add('noDisplay');
		}
		hideLoadingMessageOnSubmenu('navMessagesMenu');
	}
	function renderTrees(data) {
		var i,
			menuLength = 0,
			menuList = '',
			currentTree,
			isCurrentTree = false,
			id = 'navTrees',
			navTrees = document.getElementById(id),
			navTreesMenu = document.getElementById('navTreesMenu');
		// If no menu items
		if (!navTrees || !navTreesMenu) {
			return false;
		}
		// If bad new data or new data is same as old
		if (!data || data.success !== true || objectsAreIdentical(instance.cachedData.navTreesMenu, data)) {
			if (!instance.cachedData.navTreesMenu) { // If bad new data and no old data, remove the callout
				handleFailedMenu(id);
			}
			return false;
		}
		instance.cachedData.navTreesMenu = data;
		currentTree = data.mostRecentlyViewedTreeId || false;
		menuLength = data.menuitems.length;
		for (i = 0; i < menuLength; i += 1) {
			var menuItem = data.menuitems[i],
				url = menuItem.url,
				trackingName = url.indexOf('family-tree\/tree') >= 0 ? 'Manage Trees' : 'Family Tree';
			isCurrentTree = currentTree && url.indexOf(currentTree) !== -1;
			menuList += '<li><a data-tracking-name="' + trackingName + '" ' + (isCurrentTree ? 'class="calloutMenuChecked iconAfter iconAfterCheck" ' : '') + 'href="' + url + '">' + menuItem.text + '</a></li>';
			if (isCurrentTree) {
				navTrees.setAttribute('href', url);
			}
		}
		navTreesMenu.querySelector('ul').innerHTML = menuList;
		navTreesMenu.addEventListener('click', requestTreesData); // We shouldn't need to flush the cache on each trees request. Find a better way at some point.
		if (callouts[id]) {
			doCalloutThing(navTrees, 'position'); /* Reposition callout since it doesn't have a fixed width */
		}
	}
	function renderUpsellLink(url, text, isFullAccessFreeTrialer) {
		document.querySelectorAll('.navEmphasizedButton, .navEmphasizedTitle, .navEmphasizedExpertButton').forEach(function (el) { el.remove(); });
		if (!url && !isFullAccessFreeTrialer && expertLink) {
			/*	If they have World Explorer Plus AND
				They are not free trialers AND
				ProGen is available in their area, show the progen link as a button. */
			url = expertLink.getAttribute('href') + '-upsell';
			text = expertLink.textContent;
			var trackingName = expertLink.getAttribute('data-tracking-name') + ' : Upsell';
			var button = templates.templateEmphasizedButton
				.replace('{url}', url)
				.replace('{text}', text)
				.replace('navEmphasizedButton', 'navEmphasizedExpertButton')
				.replace('{tracking}', trackingName);
			navSecondaryMenu.insertAdjacentHTML('afterbegin', button);
		} else if (url) {
			navSecondaryMenu.insertAdjacentHTML('afterbegin', templates.templateEmphasizedButton.replace('{url}', url).replace('{text}', text).replace('{tracking}', text));
			navMobileMenu.insertAdjacentHTML('beforeend', templates.templateEmphasizedMobileButton.replace('{url}', url).replace('{text}', text).replace('{tracking}', text));
		}
	}
	function renderUsername() {
		if (!user.name) {
			return;
		}
		var accountImage = document.getElementById('navAccountImage'),
			accountUsername = document.getElementById('navAccountUsername');
		if (user.image) {
			accountImage.insertAdjacentHTML('beforebegin', '<span class="userCardImg userCardImgCenter" id="navAccountImage" style="background-image:url(\'' + user.image + '\');"><img class="navUserImage" src="' + user.image + '" alt="' + user.name + '" /></span>');
		} else {
			accountImage.insertAdjacentHTML('beforebegin', '<span class="userCardImg icon iconPerson" id="navAccountImage"></span>');
		}
		accountImage.remove();
		accountUsername.innerHTML = user.name;
	}
	function renderMobileUsername() {
		if (!user.name) {
			return;
		}
		var mobileAccountImage = document.getElementById('navAccountMobileImage'),
			accountUsernameMobile = document.getElementById('navAccountMobileUsername');
		if (user.image) {
			mobileAccountImage.insertAdjacentHTML('beforebegin', '<div aria-hidden="true" class="userCardImg userCardImgCenter" id="navAccountMobileImage" style="background-image:url(\'' + user.image + '\');"><img src="' + user.image + '" alt="' + user.name + '" /></div>');
		} else {
			mobileAccountImage.insertAdjacentHTML('beforebegin', '<div aria-hidden="true" class="userCardImg icon iconPerson" id="navAccountMobileImage"></div>');
		}
		mobileAccountImage.remove();
		accountUsernameMobile.innerHTML = user.name;
	}
	function showCount(id, count) {
		var area = document.getElementById(id),
			badge = area.querySelector('.badge');
		if (count > 0) {
			badge.innerHTML = count > 99 ? '99+' : count;
			badge.classList.remove('noDisplay');
		} else {
			badge.classList.add('noDisplay');
		}
	}
	function showDnaNotificationIcon() {
		document.getElementById('navDnaNotifications').classList.remove('noDisplay');
	}
	function showLoadingMessageOnSubmenu(submenuId) {
		var submenu = document.getElementById(submenuId + 'Loading');
		if (!submenu) {
			return;
		}
		submenu.setAttribute('aria-busy', 'true');
		submenu.classList.remove('noDisplay');
	}
	function updateCartLinks(cart) {
		if (inCartTest) {
			var button = document.querySelector('.navSecondaryMenu .navEmphasizedButton, .navSecondaryMenu .navEmphasizedExpertButton');
			if (button) {
				button.classList.add('noDisplay');
			}
			return;
		}
		var navCart = document.getElementById('navCart');
		if (cart) {
			var navCartCheckout = document.getElementById('navCartCheckout');
			navCart.setAttribute('href', cart[0].checkoutUrl);
			navCartCheckout.setAttribute('href', cart[0].checkoutUrl);
			navCart.classList.remove('noDisplay');
			document.querySelectorAll('.navSecondaryMenu .navEmphasizedButton, .navSecondaryMenu .navEmphasizedExpertButton').forEach(function (el) {
				el.classList.add('noDisplay');
			});
		} else {
			if (navCart) {
				navCart.classList.add('noDisplay');
			}
			document.querySelectorAll('.navSecondaryMenu .navEmphasizedButton, .navSecondaryMenu .navEmphasizedExpertButton').forEach(function (el) {
				el.classList.remove('noDisplay');
			});
		}
	}
	/****************************************
		Initial Setup
	*****************************************/
	function correctDomLocation() {
		var headerRegion = document.getElementById('HeaderRegion');
		var globalWrapper = document.getElementById('GlobalWrpr');
		if (globalWrapper && globalWrapper.querySelector('#HeaderRegion') && document.body.offsetWidth > headerRegion.offsetWidth) {
			globalWrapper.insertAdjacentElement('beforebegin', headerRegion);
		}
		/* Remove fixed heights from pages incorrectly setting these as inline values */
		if (headerRegion) {
			headerRegion.style.height = '';
			headerRegion.style.minHeight = '';
		}
	}
	function initCalloutSubMenus() {
		document.querySelectorAll('#nav [aria-controls]:not(.initialized)').forEach(function (el) {
			if (!ui.visible(el)) {
				return; // Only init visible callouts
			}
			initCalloutSubMenu(el);
		});
	}
	obj.addItemToCart = function (offer1, offer2) {
		if (window.phxCart) { // Created by Phoenix team
			addItemToPhxCart(offer1, offer2);
		} else {
			tempPhxCartObj = { offer1: offer1, offer2: offer2 };
			loadPhxCartScripts(true);
		}
		doCalloutThing(document.getElementById('navCart'), 'open');
		window.scrollTo(0, 0);
	};
	obj.setCartCount = function (newCount) {
		if (newCount === undefined) {
			newCount = getPhxCookieCount();
		}
		showCount('navCart', Number(newCount));
	};
	function getPhxCookieCount() {
		var currCount = 0;
		var currCountData = ui.getCookie(phxCartCookieCountName);
		if (currCountData) {
			var parsedCount = JSON.parse(currCountData);
			if (parsedCount && parsedCount.offerIdMap) {
				currCount = Object.keys(parsedCount.offerIdMap).length;
			}
		}
		return currCount;
	}
	function addItemToPhxCart(offer1, offer2) {
		if (!offer1) {
			offer1 = tempPhxCartObj.offer1;
			offer2 = tempPhxCartObj.offer2;
			tempPhxCartObj = null;
		}
		if (window.phxCart) {
			window.phxCart.addOffer(offer1, offer2);
		}
	}
	function showPhxCart() {
		window.phxCart.showCart(true);
	}
	function loadPhxCartScripts(isAddingItem) {
		if (window.phxCart) { // scripts already loaded
			if (isAddingItem) {
				addItemToPhxCart();
			}
			return;
		}
		if (phxCartRequested) { // scripts not loaded, but already requested
			return;
		}
		var head = document.head;
		var link = document.createElement('link');
		var script = document.createElement('script');
		phxCartRequested = true; // prevents requesting scripts twice
		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.href = instance.phxCartCss;
		head.appendChild(link);
		script.type = 'text/javascript';
		script.src = instance.phxCartJs;
		if (isAddingItem) {
			script.onload = function () {
				setTimeout(addItemToPhxCart, 500);
				showPhxCart();
			};
		} else {
			script.onload = showPhxCart;
		}
		head.appendChild(script);
	}
	function showPhxCartCallout(show) {
		if (!inCartTest || !window.phxCart) {
			return;
		}
		doCalloutThing(document.getElementById('navCart'), (show ? 'open' : 'close'));
	}
	function runPhxCartTest() {
		var phxCartCell = parseInt(ui.getCookie(phxCartCookieName));
		inCartTest = phxCartCell === 1 || phxCartCell === 2;
		if (!inCartTest) {
			return;
		}
		if (document.getElementById('navTemplates')) {
			prepareTemplates();
		}
		var navCart = document.getElementById('navCart');
		if (navCart) {
			navCart.remove();
		}
		var secondaryMenu = document.querySelector('.navSecondaryMenu');
		if (!secondaryMenu) {
			return;
		}
		var phxCartCount = getPhxCookieCount();
		secondaryMenu.insertAdjacentHTML('afterbegin', templates.templatePhxCart.replace('{text}', phxCartCount || ''));
		navCart = document.getElementById('navCart');
		navCart.classList.remove('noDisplay');
		showCount('navCart', phxCartCount);
		var phxCartMenu = document.getElementById('phxNavCartMenu');
		phxCartMenu.addEventListener('click', function (e) {
			e.stopPropagation();
			if (!phxCartMenu.contains(document.activeElement)) {
				phxCartMenu.focus();
			}
		});
		initCalloutSubMenu(navCart);
	}
	function initCalloutSubMenu(el) {
		var hasUnviewedBadge,
			badgeTimer,
			submenuId = el.getAttribute('aria-controls'),
			submenu = document.getElementById(submenuId),
			classes = 'calloutMenu navCalloutMenu',
			isBadgeable = el.classList.contains('navMainLink'),
			isHintsMenu = el.classList.contains('navHints'),
			isCartMenu = el.classList.contains('navCart'),
			isAccountMenu = el.classList.contains('navAccount'),
			isDnaNotificationsMenu = el.classList.contains('navDnaNotifications'),
			menuToUpdate = submenuId.toLowerCase().replace('nav', '').replace('menu', ''),
			clickedClearCart = function () {
				doCalloutThing(el, 'close');
				clearCart();
			},
			calloutConfig = {
				'content': '#' + submenuId,
				'classes': classes,
				'disableAutofocusOnOpen': true,
				'onOpen': function ($trigger) {
					var trigger = $trigger ? $trigger[0] : this;
					var badge = trigger.querySelector('.badge');
					hasUnviewedBadge = !!badge && ui.visible(badge);
					trigger.setAttribute('aria-expanded', true);
					submenu.setAttribute('aria-expanded', true);
					if (instance.isLoggedIn) { // && !trigger.data('already-loaded')) {
						obj.updateUserData(menuToUpdate);
						trigger.setAttribute('data-already-loaded', 'true');
					}
					if (isBadgeable && instance.isLoggedIn) {
						if (hasUnviewedBadge) {
							badgeTimer = setTimeout(function () {
								submenu.querySelector('.badge').setAttribute('data-badge-viewed', true);
								// TODO: Animate
								var spacer = badge.previousSibling;
								if (spacer && spacer.classList.contains('navSpacer')) {
									spacer.remove();
								}
								badge.remove();
								setBadgeCookie();
							}, 1000);
						}
						submenu.removeEventListener('click', clickedBadge);
						submenu.addEventListener('click', clickedBadge);
					}
					if (isCartMenu) {
						if (inCartTest) {
							loadPhxCartScripts(false);
							if (window.phxCart) {
								phxCart.showCart(true);
							}
						} else {
							document.getElementById('navCartEmpty').addEventListener('click', clickedClearCart);
						}
					} else if (isHintsMenu && hasUnviewedBadge) {
						badgeTimer = setTimeout(clearHints, 3000);
					} else if (isDnaNotificationsMenu && hasUnviewedBadge) {
						badgeTimer = setTimeout(clearDnaNotifications, 3000);
					} else if (isAccountMenu) {
						renderMobileUsername();
					}
				},
				'onClose': function ($trigger) {
					var trigger = $trigger ? $trigger[0] : this;
					trigger.setAttribute('aria-expanded', 'false');
					submenu.setAttribute('aria-expanded', 'false');
					if (hasUnviewedBadge) {
						clearTimeout(badgeTimer);
					}
					if (isCartMenu && !inCartTest) {
						document.getElementById('navCartEmpty').removeEventListener('click', clickedClearCart);
					}
					if (instance.addTracking) {
						trigger.classList.add('closing');
						setTimeout(function () {
							trigger.classList.remove('closing');
						});
					}
				}
			};
		if (ui.callout) {
			callouts[el.id] = ui.callout(el, calloutConfig);
		} else if ($.callout) {
			$(el).callout(calloutConfig);
			callouts[el.id] = $(el).data('calloutInstance');
		} else {
			warn('Header Error: Missing core.js dependency. DO NOT IGNORE. This is an issue with your page.');
		}
		el.classList.add('link');
		el.classList.add('initialized');
		el.addEventListener('keyup', handleKeyUp);
		el.addEventListener('keydown', handleKeyDown);
	}
	function initializeHeader() {
		initUI();
		if (instance.showHireAnExpertWarning) {
			bindExpertWarning();
		}
		 // store expertLink before it's removed from the DOM
		expertLink = document.getElementById('navLinkExpert');
		navSecondaryMenu = document.querySelector('.navSecondaryMenu');
		navMobileMenu = document.querySelector('.navMobileMenu');
		correctDomLocation();
		obj.setSelectedPage(instance.selectedTabName);
		if (instance.isLoggedIn) {
			personalizeHeader();
			handleBadges();
		}
		runPhxCartTest();
		bindEvents();
	}
	function loadUserInfo(bypassCache) {
		if (instance.ajaxUrl) {
			var options = {
				'url': instance.ajaxUrl + (bypassCache ? '?bypassCache=true' : ''),
				'success': function (data) {
					if (data.user) {
						user = data.user;
						renderUsername();
						renderUpsellLink(user.subscribeUrl, user.subscribeText, user.isFullAccessFreeTrialer);
						updateCartLinks(data.cart);
						showCount('navMessages', data.messagecount);
						showCount('navHints', data.hintcount);
						if (data.showDnaNotification) {
							showDnaNotificationIcon();
							showCount('navDnaNotifications', data.dnaCount);
						}
						initCalloutSubMenus(); /* Needed to init the cart and dna notification menus */
					}
					var unloadedMenu = document.querySelector('.navSecondaryMenuUnloaded');
					if (unloadedMenu) {
						unloadedMenu.classList.remove('navSecondaryMenuUnloaded');
					}
				}
			};
			if (instance.testing) {
				options.testResponse = instance.testing.userinfo;
			}
			ajax(options);
		}
	}
	function personalizeHeader() {
		prepareTemplates();
		renderCachedMenuOrDisplayLoadingMessage('trees', 'navTreesMenu', renderTrees);
		renderCachedMenuOrDisplayLoadingMessage('hints', 'navHintsMenu', renderHints);
		renderCachedMenuOrDisplayLoadingMessage('messages', 'navMessagesMenu', renderMessages);
		renderCachedMenuOrDisplayLoadingMessage('dnaNotifications', 'navDnaNotificationsMenu', renderDnaNotifications);
		loadUserInfo();
	}
	function prepareTemplates() {
		var navTemplates = document.getElementById('navTemplates');
		if (templates !== null || !navTemplates) {
			return;
		}
		templates = {
			'templateNew': document.getElementById('templateNew').innerHTML,
			'templatePhxCart': document.getElementById('templateCart').innerHTML,
			'templateBadge': document.getElementById('templateBadge').innerHTML,
			'templateNotification': document.getElementById('templateNotification').innerHTML,
			'templateNotificationTypeIcon': document.getElementById('templateNotificationTypeIcon').innerHTML,
			'templateNotificationUsercardIcon': document.getElementById('templateNotificationUsercardIcon').innerHTML,
			'templateNotificationUsercardImage': document.getElementById('templateNotificationUsercardImage').innerHTML,
			'templateEmphasizedButton': document.getElementById('templateEmphasizedButton').innerHTML,
			'templateEmphasizedMobileButton': document.getElementById('templateEmphasizedMobileButton').innerHTML
		};
		navTemplates.remove();
	}
	/****************************************
		Exposed Methods
	*****************************************/
	obj.runPhxCartTest = runPhxCartTest;
	obj.showCart = showPhxCartCallout;
	obj.setReturnUrl = function (returnUrl) {
		var link = document.getElementById('navAccount'),
			href = link.getAttribute('href');
		href = updateQueryStringParameter(href, 'returnUrl', encodeURIComponent(returnUrl));
		link.setAttribute('href', href);
	};
	obj.setSelectedPage = function (selectedTabName) {
		if (selectedTabName) {
			var nav = document.getElementById('nav');
			var selectedTabClass = 'nav' + selectedTabName;
			nav.querySelectorAll('.navLinkSelected').forEach(function (el) {
				if (el.classList.contains(selectedTabClass)) {
					return;
				}
				el.classList.remove('navLinkSelected');
			});
			var selectedTab = nav.querySelector('.' + selectedTabClass);
			if (selectedTab) {
				selectedTab.classList.add('navLinkSelected');
			}
		}
	};
	obj.updateUserData = function (key) {
		switch (key) {
			case 'trees':
			case 'mobile':
				loadSubMenu(instance.treesAjaxUrl, renderTrees, 'trees');
				break;
			case 'hints':
				loadSubMenu(instance.hintsAjaxUrl + '?bypassCache=true', renderHints, 'hints');
				break;
			case 'messages':
				loadSubMenu(instance.messagesAjaxUrl + '?bypassCache=true', renderMessages, 'messages');
				break;
			case 'user':
				loadUserInfo(true);
				break;
			case 'dna':
				loadSubMenu(instance.dnaUrl + '/rest/headerinfo', renderDna, 'dna');
				break;
			case 'dnanotifications':
				loadSubMenu(instance.dnaNotificationsAjaxUrl, renderDnaNotifications, 'dnaNotifications');
				break;
		}
	};
	obj.init = function (options) {
		if (instance !== undefined) {
			unbindEvents();
		}
		instance = settings;
		for (var attr in options) {
			if (options.hasOwnProperty(attr)) {
				instance[attr] = options[attr];
			}
		}
		if (!instance.cachedData) {
			instance.cachedData = {};
		}
		if (ui && ui.callout || $ && $.callout) {
			initializeHeader();
		} else {
			setTimeout(initializeHeader, 20); /* Needs timeout since callout.js is likely to be loaded after header.js */
		}
		return instance;
	};
	return obj;
}(window.jQuery));
